import { render } from "./VTextBlockDecoratorStatus.vue?vue&type=template&id=fd57332a&scoped=true"
import script from "./VTextBlockDecoratorStatus.vue?vue&type=script&lang=js"
export * from "./VTextBlockDecoratorStatus.vue?vue&type=script&lang=js"

import "./VTextBlockDecoratorStatus.vue?vue&type=style&index=0&id=fd57332a&scoped=true&lang=scss"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd57332a"]])

export default __exports__